import { Flex, Typography, theme } from 'antd';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import StatusComponent from 'components/status/status';

interface SharesCountProps {
	title: string;
	total: number;
	free: number;
	suspended: number;
	mortgaged: number;
	fullWidth?: boolean;
}

const SharesCount: FunctionComponent<SharesCountProps> = ({ free, mortgaged, suspended, title, total, fullWidth }) => {
	const { t } = useTranslation();

	return (
		<>
			<Typography.Text style={{ fontSize: 15, marginBottom: 5, display: 'inline-block' }}>{title}</Typography.Text>
			<Flex align="center" gap={10} wrap className={`inputDiv ${fullWidth ? 'fullWidth' : ''}`}>
				<StatusComponent small bordered color="green" text={`${t('COMMON.TOTAL')}: ${total.toLocaleString()}`} />

				<StatusComponent small bordered color="white" text={`${t('COMMON.FREE')}: ${free.toLocaleString()}`} />

				<StatusComponent small bordered color="orange" text={`${t('COMMON.SUSPENDED')}: ${suspended.toLocaleString()}`} />
				
				<StatusComponent small bordered color="red" text={`${t('COMMON.MORTGAGED')}: ${mortgaged.toLocaleString()}`} />
			</Flex>
		</>
	);
};

export default SharesCount;
